import React, { Component, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { sagaModal } from 'redux-saga-modal';
import {
  Form,
  Tabs,
  Modal,
  Input,
  Divider,
  Upload,
  Icon,
  Button,
  message,
  Row, Col,
} from 'antd';
import styles from './tenantInfoDialog.module.scss';
import SelectUser from '@/components/SelectUser';
import AssetsManager from './assetsManager';
import * as actions from '@/models/tenants/actions';
import * as apis from '@/apis';
import debounce from 'lodash/debounce';
const tenantMode = process.env.APP_MODE === 'tenant'
const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 15 },
};

@connect()
@Form.create()
class CreateModal extends Component {
  state = {
    loading: false,
    tab: 1,
  };

  onUploadStart = (file) => {
    this.setState({ loading: true });
  };

  tabOnChange = (key) => {
    this.setState({
      tab: key,
    });
  };

  customRequest = ({ file }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'tenant-logo');

    apis
      .uploadFile(formData)
      .then((response) => {
        this.setState({ loading: false });

        this.props.form.setFieldsValue({
          logo:
            response.url +
            '?x-oss-process=image/resize,m_fill,h_320,w_320/format,jpg',
        });
      })
      .catch((err) => {
        this.setState({ loading: false });

        message.error(err.message || '图片上传失败');
        console.error('onError', err);
      });

    return {
      abort() {
        console.log('upload progress is aborted.');
      },
    };
  };

  customLicenceRequest = ({ file }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'tenant-licence');

    apis
      .uploadFile(formData)
      .then((response) => {
        this.setState({ loading: false });

        this.props.form.setFieldsValue({
          licence:
            response.url +
            '?x-oss-process=image/resize,m_fill,h_320,w_320/format,jpg',
        });
      })
      .catch((err) => {
        this.setState({ loading: false });

        message.error(err.message || '图片上传失败');
        console.error('onError', err);
      });

    return {
      abort() {
        console.log('upload progress is aborted.');
      },
    };
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.handleSubmit2()
  };

  handleSubmit2 = debounce(() => {
    const { dispatch, tenant, onSuccess } = this.props;
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err);
      }

      if (tenant && tenant._id) {
        dispatch(actions.updateTenant(tenant._id, values));
      } else {
        dispatch(actions.createTenant(values));
      }

      onSuccess(values);
    });
  }, 500);

  normalizeUser = (value, prevValue, allValues) => {
    if (typeof value === 'string') {
      return value;
    }

    if (value && value._id) {
      return value._id;
    }

    return null;
  };

  render() {
    const { tenant } = this.props;
    const { getFieldDecorator, validateFields, getFieldValue } =
      this.props.form;
    const data = {};
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">上传</div>
      </div>
    );

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <div className={styles.wrap}>
            <div>
              <Divider orientation="left">
                <span className={styles.sectionTit}>基本信息</span>
              </Divider>
              <Form.Item
                {...formItemLayout}
                label="企业名称"
                extra="必须与工商注册号一致"
                required
              >
                {getFieldDecorator('name', {
                  initialValue: tenant && tenant.name,
                  rules: [
                    {
                      required: true,
                      message: '请输入企业完整名称',
                    },
                  ],
                })(
                  <Input max={10} autoFocus placeholder="请输入企业完整名称" />
                )}
              </Form.Item>
              <Form.Item
                {...formItemLayout}
                label="营业执照税号"
              >
                {getFieldDecorator('tax_no', {
                  initialValue: tenant && tenant.tax_no,
                  rules: [
                    {
                      required: false,
                      message: '请输入营业执照税号',
                    },
                  ],
                })(
                  <Input max={10} placeholder="请输入营业执照税号" />
                )}
              </Form.Item>
              <Form.Item {...formItemLayout} label="公司简称" required>
                {getFieldDecorator('short_name', {
                  initialValue: tenant && tenant.short_name,
                  rules: [
                    {
                      required: true,
                      message: '请输入公司简称',
                    },
                  ],
                })(<Input max={10} placeholder="请输入公司简称" />)}
              </Form.Item>
              <Form.Item
                {...formItemLayout}
                label="LOGO"
                extra="请上传 320x320px 的图片"
              >
                {getFieldDecorator('logo', {
                  initialValue: tenant && tenant.logo,
                  rules: [
                    {
                      required: false,
                      message: '请上传LOGO',
                    },
                  ],
                })(
                  <Upload
                    accept=".png, .jpg, .jpeg"
                    multiple={false}
                    name="avatar"
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    onStart={this.onUploadStart}
                    customRequest={this.customRequest}
                  >
                    {getFieldValue('logo') ? (
                      <img
                        src={getFieldValue('logo')}
                        width="120"
                        alt="avatar"
                      />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                )}
              </Form.Item>
              <Form.Item
                {...formItemLayout}
                label="营业执照"
              >
                {getFieldDecorator('licence', {
                  initialValue: tenant && tenant.licence,
                  rules: [
                    {
                      required: false,
                      message: '请上传营业执照',
                    },
                  ],
                })(
                  <Upload
                    accept=".png, .jpg, .jpeg"
                    multiple={false}
                    name="licence"
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    onStart={this.onUploadStart}
                    customRequest={this.customLicenceRequest}
                  >
                    {getFieldValue('licence') ? (
                      <img
                        src={getFieldValue('licence')}
                        width="120"
                        alt="licence"
                      />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                )}
              </Form.Item>
            </div>
            <div>
              <Divider orientation="left">
                <span className={styles.sectionTit}>联系信息</span>
              </Divider>
              <Form.Item {...formItemLayout} label="公司地址">
                {getFieldDecorator('address', {
                  initialValue: tenant && tenant.address,
                  rules: [
                    {
                      required: false,
                      message: '请输入详细公司地址',
                    },
                  ],
                })(<Input max={10} placeholder="请输入详细公司地址" />)}
              </Form.Item>
              <Form.Item {...formItemLayout} label="联系人姓名">
                {getFieldDecorator('contact_name', {
                  initialValue: tenant && tenant.contact_name,
                  rules: [
                    {
                      required: false,
                      message: '请输入联系人姓名',
                    },
                  ],
                })(<Input max={10} placeholder="请输入联系人姓名" />)}
              </Form.Item>
              <Form.Item {...formItemLayout} label="联系电话">
                {getFieldDecorator('contact_tel', {
                  initialValue: tenant && tenant.contact_tel,
                  rules: [
                    {
                      required: false,
                      message: '请输入联系电话',
                    },
                  ],
                })(<Input max={10} placeholder="请输入联系电话" />)}
              </Form.Item>
              <Form.Item {...formItemLayout} label="技术支持电话">
                {getFieldDecorator('tech_tel', {
                  initialValue: tenant && tenant.tech_tel,
                  rules: [
                    {
                      required: false,
                      message: '请输入技术支持电话',
                    },
                  ],
                })(<Input max={10} placeholder="多个技术支持电话空格分隔" />)}
              </Form.Item>
              <Form.Item {...formItemLayout} label="财务负责人电话">
                {getFieldDecorator('finance_tel', {
                  initialValue: tenant && tenant.finance_tel,
                  rules: [
                    {
                      required: false,
                      message: '请输入财务负责人电话',
                    },
                  ],
                })(<Input max={10} placeholder="请输入财务负责人电话" />)}
              </Form.Item>
              {
                // 创建企业时无需填写管理员，修改时必填。
                // 创建完后先添加为员工，再设置为管理员
                tenant && (
                  <Form.Item
                    {...formItemLayout}
                    label="企业管理员"
                    extra="必须是关注公众号且验证手机号的用户"
                    required
                  >
                    {getFieldDecorator('owner', {
                      initialValue: tenant?.owner?._id,
                      normalize: this.normalizeUser,
                      rules: [
                        {
                          required: true,
                          message: '请选择管理员',
                        },
                      ],
                    })(<SelectUser placeholder="请输入管理员手机号" />)}
                  </Form.Item>
                )
              }
              {tenant && <Row>
                <Col span={7}>
                  <span style={{ color: '#333' }}>工单默认同意价格区间：</span>
                </Col>
                <Col span={15}>
                  <Row>
                    <Col span={11}>
                      <Form.Item>
                        {getFieldDecorator('quotationStart', {
                          initialValue: tenant && tenant.quotationStart,
                          rules: [
                            {
                              required: false,
                              message: '请输入开始价格',
                            },
                          ],
                        })(<Input placeholder="开始价格" />)}
                      </Form.Item>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: 'center' }}>—</div>
                    </Col>
                    <Col span={11}>
                      <Form.Item>
                        {getFieldDecorator('quotationEnd', {
                          initialValue: tenant && tenant.quotationEnd,
                          rules: [
                            {
                              required: false,
                              message: '请输入结束价格',
                            },
                          ],
                        })(<Input placeholder="结束价格" />)}
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>}
              {!tenantMode && (
                <Form.Item {...formItemLayout} label="备注" required>
                  {getFieldDecorator('memo', {
                    initialValue: tenant && tenant.memo,
                  })(<Input.TextArea placeholder="备注内容" />)}
                </Form.Item>)}
            </div>
          </div>
          <div className={styles.footer}>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const TenantnfoDialog = ({
  modal: { name },
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => {
  return (
    <Modal
      title={ownProps.title}
      destroyOnClose
      footer={null}
      width={860}
      style={{ top: 30 }}
      visible={isOpen}
      onCancel={hide}
    >
      <Tabs
        defaultActiveKey={ownProps.tab || '1'}
        className={styles.tabs}
        // onChange={this.tabOnChange}
        type="card"
      >
        <Tabs.TabPane key="1" tab="基本信息">
          <CreateModal onSuccess={submit} {...ownProps} />
        </Tabs.TabPane>
        {ownProps.tenant && (
          <Tabs.TabPane key="2" tab="企业资料">
            <AssetsManager {...ownProps}></AssetsManager>
          </Tabs.TabPane>
        )}
      </Tabs>
    </Modal>
  );
};

export default sagaModal({
  name: 'TENANT_INFO_DIALOG',
})(TenantnfoDialog);
